import { Button, Tooltip } from '@tecsinapse/cortex-react'
import React, { ReactNode } from 'react'
import { rightComponentVariants } from '../styles'

interface RightComponentButtonProps {
  title: string
  icon: ReactNode
  onClick: () => void
}

const { iconStyle } = rightComponentVariants()

const RightComponentButton = ({ title, icon, onClick }: RightComponentButtonProps) => (
  <Tooltip
    text={title}
    placement='bottom'
  >
    <Button
      intent='secondary'
      size='square'
      variant='text'
      onClick={onClick}
    >
      <div className={iconStyle()}>{icon}</div>
    </Button>
  </Tooltip>
)

export default RightComponentButton
